import type { WindowKey } from 'owa-bizchat-types';
import type { MailboxInfo } from 'owa-client-types';
import { setTasksHubActiveMutator } from '../mutators/setTasksHubActiveMutator';
import { logTasksHubViewed, type TasksHubViewSource } from './logTasksHubViewed';

export function showTasksHub(
    windowKey: WindowKey,
    mailboxInfo: MailboxInfo,
    source: TasksHubViewSource
): void {
    setTasksHubActiveMutator(windowKey, true);
    logTasksHubViewed(mailboxInfo, source);
}
